import React from 'react';

import { useForm } from 'react-hook-form';
import { Card, CardBody, CardHeader, Col, Form, Row } from 'reactstrap';
import { H5, Btn } from '../../../AbstractElements';
import { BankNameOption, NetBankingTitle, Submit } from '../../../Constant';

import InputControl from '../../Common/FormInputs/InputControl';

const NetBanking = () => {
  const {
    register,
    control,
    formState: { errors },
  } = useForm();

  return (
    <>
      <Col xl='4' lg='6' className='box-col-33 debit-card '>
        <Card>
          <CardHeader className='pb-0'>
            <H5>{NetBankingTitle}</H5>
          </CardHeader>
          <CardBody>
            <Form className='theme-form' >
              <Row>
                <Col sm='12' className='p-r-0'>
                  <InputControl label={false} controlInput='input' className='form-control' type='text' errors={errors} register={{ ...register('ac_holder_name', { required: 'is Required.' }) }} />
                </Col>
                <Col sm='12' className='p-r-0'>
                  <InputControl label={false} controlInput='input' className='form-control' type='number' errors={errors} register={{ ...register('account_number', { required: 'is Required.', maxLength: 16, minLength: 16 }) }} />
                </Col>
                <Col sm='6'>
                  <InputControl label={false} control={control} controlInput='select' placeholder='Select Bank' options={BankNameOption} className='form-select' errors={errors} register={{ ...register('bank_name', { required: 'is Required.' }) }} />
                </Col>
                <Col sm='6' className='p-r-0'>
                  <InputControl label={false} controlInput='input' className='form-control' type='text' errors={errors} register={{ ...register('ICFC_code', { required: 'is Required.', maxLength: 11, minLength: 11 }) }} />
                </Col>
                <Col sm='12' className='p-r-0'>
                  <InputControl label={false} controlInput='input' className='form-control' placeholder='Enter Mobile Number' type='number' errors={errors} register={{ ...register('mobile_number', { required: 'is Required.', maxLength: 12, minLength: 12 }) }} />
                </Col>
                <Col sm='12' className='p-r-0'>
                  <InputControl label={false} controlInput='input' className='form-control' type='text' errors={errors} register={{ ...register('other_Details', { required: 'is Required.' }) }} />
                </Col>
                <Col sm='12'>
                  <Btn color='primary' className='btn-block' type='submit'>
                    {Submit}
                  </Btn>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default NetBanking;
